import { render, staticRenderFns } from "./BankIntegrationUpdateValue.vue?vue&type=template&id=3f1a4650"
import script from "./BankIntegrationUpdateValue.vue?vue&type=script&lang=js"
export * from "./BankIntegrationUpdateValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports